// Predefined pickup time slots used across the app.
// Stored value -> friendly display string.
// `startHour` is used to disable slots whose start time is already in the past
// when the customer selects today's date.

export const PICKUP_TIME_SLOTS = [
  { value: 'MORNING_8_11',    label: 'MORNING',   range: '8:00 AM - 11:00 AM', startHour: 8 },
  { value: 'AFTERNOON_13_16', label: 'AFTERNOON', range: '1:00 PM - 4:00 PM',  startHour: 13 },
  { value: 'EVENING_17_20',   label: 'EVENING',   range: '5:00 PM - 8:00 PM',  startHour: 17 }
];

export const formatPickupSlot = (value) => {
  if (!value) return '';
  const slot = PICKUP_TIME_SLOTS.find(s => s.value === value);
  if (slot) return `${slot.label} (${slot.range})`;
  // Backward-compat: handles old HH:MM values
  return value;
};

/**
 * Decide whether a pickup slot is selectable for the given date.
 * - Only blocks slots when `dateStr` (YYYY-MM-DD) matches today's local date.
 * - A slot is blocked if its start hour has already passed
 *   (1-hour booking lead time enforced — agent needs prep time).
 */
export const isPickupSlotDisabled = (slot, dateStr) => {
  if (!dateStr || !slot) return false;
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const dd = String(today.getDate()).padStart(2, '0');
  const todayStr = `${yyyy}-${mm}-${dd}`;
  if (dateStr !== todayStr) return false;
  // 1-hour lead time: slot must start at least 1h after now
  const cutoffHour = today.getHours() + (today.getMinutes() > 0 ? 1 : 0) + 1;
  return slot.startHour < cutoffHour;
};
